import {
  MdClose,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdOutlineEco,
  MdRestaurant,
  MdDeliveryDining,
  MdLocalOffer,
  MdAccessTime,
  MdStar,
  MdCurrencyRupee,
} from "react-icons/md";
import { useState } from "react";
import "./AdvancedFilterModal.css";

const FOOD_TYPES = [
  "Veg",
  "Non Veg",
];

const CATEGORIES = [
  "South Indian",
  "North Indian",
  "Chinese",
  "Italian",
  "Fast Food",
  "Bakery",
  "Desserts",
  "Beverages",
];

const PROVIDERS = [
  "Home Chef",
  "Restaurant",
  "Hotel",
  "Bakery",
  "Cafe",
  "Catering",
  "Provision Store",
];

const BUDGETS = [
  100,
  200,
  300,
  500,
];

const RATINGS = [
  4,
  4.5,
];

function AdvancedFilterModal({
  filters,
  onFilterChange,
  onReset,
  onClose,
}) {

    const [openSection, setOpenSection] = useState("food");

const toggleSection = (section) => {

  setOpenSection(
    openSection === section
      ? null
      : section
  );

};

  const toggleFoodType = (value) => {

    onFilterChange(
      "foodType",
      filters.foodType === value ? "" : value
    );

  };

  const toggleCategory = (value) => {

    onFilterChange(
      "category",
      filters.category === value ? "" : value
    );

  };

  const toggleProvider = (value) => {

    onFilterChange(
      "providerType",
      filters.providerType === value ? "" : value
    );

  };

  const toggleBudget = (value) => {

    onFilterChange(
      "maxPrice",
      filters.maxPrice === value ? "" : value
    );

  };

  const toggleRating = (value) => {

    onFilterChange(
      "rating",
      filters.rating === value ? "" : value
    );

  };

  return (

    <>
      <div
        className="filter-overlay"
        onClick={onClose}
      />

      <div className="advanced-filter">

        <div className="advanced-filter-header">

          <h2>Filters</h2>

          <button
            className="close-btn"
            onClick={onClose}
          >
            <MdClose />
          </button>

        </div>

        <div className="advanced-filter-body">

          <section>

            <button
    className="filter-section-header"
    onClick={() => toggleSection("food")}
>

    <span>Food Type</span>

    {openSection === "food"
        ? <MdKeyboardArrowUp />
        : <MdKeyboardArrowDown />}

</button>

{openSection === "food" && (

<div className="chip-group">

              {FOOD_TYPES.map((item) => (

                <button
                  key={item}
                  className={`chip ${
                    filters.foodType === item
                      ? "active"
                      : ""
                  }`}
                  onClick={() =>
                    toggleFoodType(item)
                  }
                >
                  {item === "Veg"
                    ? <MdOutlineEco />
                    : <MdRestaurant />}

                  {item}

                </button>

              ))}

           </div>

)}

</section>
                    <section>

           <button
    className="filter-section-header"
    onClick={() => toggleSection("cuisine")}
>

<span>Cuisine</span>

{openSection==="cuisine"
? <MdKeyboardArrowUp/>
: <MdKeyboardArrowDown/>
}

</button>

{openSection==="cuisine" && (

<div className="chip-group">

              {CATEGORIES.map((item) => (

                <button
                  key={item}
                  type="button"
                  className={`chip ${
                    filters.category === item
                      ? "active"
                      : ""
                  }`}
                  onClick={() => toggleCategory(item)}
                >
                  <MdRestaurant />
                  {item}
                </button>

              ))}

           </div>

)}

</section>

          <section>

            <h4>Services</h4>

            <div className="chip-group">

              {PROVIDERS.map((item) => (

                <button
                  key={item}
                  type="button"
                  className={`chip ${
                    filters.providerType === item
                      ? "active"
                      : ""
                  }`}
                  onClick={() => toggleProvider(item)}
                >
                  <MdDeliveryDining />
                  {item}
                </button>

              ))}

            </div>

          </section>

          <section>

            <h4>Budget</h4>

            <div className="chip-group">

              {BUDGETS.map((price) => (

                <button
                  key={price}
                  type="button"
                  className={`chip ${
                    filters.maxPrice === price
                      ? "active"
                      : ""
                  }`}
                  onClick={() => toggleBudget(price)}
                >
                  <MdCurrencyRupee />
                  {`Under ₹${price}`}
                </button>

              ))}

            </div>

          </section>
                    <section>

            <h4>Rating</h4>

            <div className="chip-group">

              {RATINGS.map((rating) => (

                <button
                  key={rating}
                  type="button"
                  className={`chip ${
                    filters.rating === rating
                      ? "active"
                      : ""
                  }`}
                  onClick={() => toggleRating(rating)}
                >
                  <MdStar />
                  {rating}+ Rating
                </button>

              ))}

            </div>

          </section>

          <section>

            <h4>Other Filters</h4>

            <div className="chip-group">

              <button
                type="button"
                className={`chip ${
                  filters.fastDelivery ? "active" : ""
                }`}
                onClick={() =>
                  onFilterChange(
                    "fastDelivery",
                    !filters.fastDelivery
                  )
                }
              >
                <MdDeliveryDining />
                Fast Delivery
              </button>

              <button
                type="button"
                className={`chip ${
                  filters.openNow ? "active" : ""
                }`}
                onClick={() =>
                  onFilterChange(
                    "openNow",
                    !filters.openNow
                  )
                }
              >
                <MdAccessTime />
                Open Now
              </button>

              <button
                type="button"
                className={`chip ${
                  filters.offersOnly ? "active" : ""
                }`}
                onClick={() =>
                  onFilterChange(
                    "offersOnly",
                    !filters.offersOnly
                  )
                }
              >
                <MdLocalOffer />
                Offers Only
              </button>

            </div>

          </section>

        </div>

        <div className="advanced-filter-footer">

          <button
            type="button"
            className="reset-btn"
            onClick={onReset}
          >
            Reset Filters
          </button>

          <button
            type="button"
            className="apply-btn"
            onClick={onClose}
          >
            Apply Filters
          </button>

        </div>

      </div>

    </>
  );

}

export default AdvancedFilterModal;